export default __webpack_public_path__ + "static/media/First-nft.31e793cd.png";